/////////////////////////////////////////////////////
// Add your custom code here.
// This file and any changes you make to it are preserved every time the app is generated.
/////////////////////////////////////////////////////
import { Inject, Injector } from '@angular/core';
import { SelectionEvent } from '@progress/kendo-angular-grid';
import { RacuniViewBaseComponent } from './racuni.view.base.component';

export class RacuniViewComponent extends RacuniViewBaseComponent {
    constructor(@Inject(Injector) injector: Injector) {
        super(injector);
    }

    // Fired when component is initialized and input properties are set
    public onInit(): void {}
    // Fired when component's views and child views are initialized
    public onShow(): void { }
    // Fired just before Angular destroys the component. Unsubscribe Observables and detach event handlers to avoid memory leaks
    public onHide(): void {}
    public onRowSelect(e: SelectionEvent): void {}

}



// WEBPACK FOOTER //
// C:/Users/vjug.INFODESIGN/OtvoreniGrad2/app/src/app/modules/transparentnost/racuni/racuni.view.component.ts